<template>
    <div>
      <div class="e-filter-container">
      <a v-b-toggle.sidebar-right.sidebar-backdrop class="e-filter-btn"><i class="lnr lnr-funnel"></i></a>
    </div>
    <filters-component v-on:fromFilter="filter" :filterType="filterType"></filters-component>
      <div class="e-loader-back" v-if="loading">
            <div class="e-loader-content">
              <div class="ball-clip-rotate-multiple">
                <div></div>
                <div></div>
              </div>
              <div class="e-nusx-8 e-bold e-loader-text">იტვირთება...</div>
            </div>
          </div>
      <add-new-request @RequestAdded="loadItems()"></add-new-request>
      <add-new-request-v2 @RequestAdded="loadItems()"></add-new-request-v2>
         <vue-good-table
         ref="requestsTable"
      mode="remote"
    @on-page-change="onPageChange"
    @on-sort-change="onSortChange"
    @on-column-filter="onColumnFilter"
    @on-per-page-change="onPerPageChange"
    :search-options="{enabled: true, placeholder: 'სახელი ან გვარი (მოსაძებნად დააჭირეთ Enter-ს)', trigger: 'enter', class: 'test'}"
    :totalRows="totalRecords"
    @on-row-click="RR_Table_RowClick"
    @on-search="onSearch"
    :pagination-options="{
                                    enabled: true,
                                    mode: 'records',
                                    perPage: 5,
                                    position: 'top',
                                    perPageDropdown: [10, 15, 25, 50],
                                    dropdownAllowAll: false,
                                    setCurrentPage: 1,
                                    nextLabel: 'შემდეგი',
                                    prevLabel: 'წინა',
                                    rowsPerPageLabel: 'ნაჩვენები ჩანაწერების რაოდენობა',
                                    ofLabel: '-ჩანაწერი სულ',
                                    pageLabel: 'გვერდი', // for 'pages' mode
                                    allLabel: 'ყველა',
                                  }"
      :columns="RequestsTablecolumns"
      :rows="RequestsTablerows"
      >
      <div slot="table-actions">
              <!-- <button class="btn btn-link e-mtavr-17 btn-outline-secondary" @click="filterToggle()">
                <i class="lnr lnr-funnel mr-2"></i> ფილტრები
              </button> -->
              <!-- <button class="btn btn-link e-mtavr-17 btn-outline-secondary" v-b-modal.excelImportModal>
                <i class="lnr lnr-download mr-2"></i> ექსელიდან იმპორტი
              </button> -->
              <!-- <b-button v-b-modal.addRequestModal>Show Modal</b-button> -->
              <button class="btn btn-link e-mtavr-17 btn-outline-secondary" @click="exportToExcel()">
                <i class="lnr lnr-upload mr-2"></i> ექსელში ექსპორტი
              </button>
              <!-- <download-excel class="btn btn-link e-mtavr-17 btn-outline-purple"
    :data   = "json_data">
   <i class="fas fa-file-export mr-2"></i> ექსელში ექსპორტი
              </download-excel>-->
              <!-- <b-button
                class="btn btn-link e-mtavr-17 btn-outline-secondary mr-2"
                v-b-modal.addRequestModal
              >
                <i class="lnr lnr-file-add mr-2"></i> ახალი მოთხოვნა
              </b-button> -->
              <b-button
                class="btn btn-link e-mtavr-17 btn-outline-secondary mr-2"
                v-b-modal.addRequestv2Modal
              >
                <i class="lnr lnr-file-add mr-2"></i> ახალი მოთხოვნა
              </b-button>
            </div>
            <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field == 'ScrStatus'">
                <div
                  v-if="props.row.matchCount > 0 || props.row.dboforigination ==='BlackList'"
                  class="badge badge-danger e-nusx-8"
                >საყურადღებო</div>
                <div v-else class="badge badge-success e-nusx-8">არცერთი დამთხვევა</div>
              </div>
              <div v-else-if="props.column.field == 'Deci'">
                <div v-if="props.row.dboforigination ==='BlackList'"
                  class="badge badge-outline-danger ml-1 mr-1 mb-1 pt-1 float-left e-ts-07rem"
                > Black List </div>
                <div v-for="d in props.row.decisionsArry" :key="d.$index"
                  class="badge badge-outline-danger ml-1 mr-1 mb-1 float-left e-ts-07rem"
                >{{ d }}</div>
              </div>
              <!-- <div v-else-if="props.column.field == 'functions'" class="e-whitespace-nowrap">
                <button
                  class="btn btn-info icon-btn btn-sm"
                  title="სკანირების რეზულტატების ნახვა"
                  v-if="props.row.matchCount > 0"
                >
                  <span class="lnr lnr-magnifier"></span>
                </button>
              </div> -->
            </template>
      </vue-good-table>
    </div>
</template>
<script>
import BaseService from '@/backend/vue-axios/axios.js'
import addNewRequest from '../components/addNewRequest'
import addNewRequestV2 from '../components/addNewRequest3.vue'
import FiltersComponent from '../components/filters.vue'
import moment from 'moment'
import XLSX from 'xlsx'
export default {
  name: 'registeredRequests',
  components: {
    addNewRequest,
    addNewRequestV2,
    FiltersComponent
  },
  metaInfo: {
    title: ' - ყველა მოთხოვნა'
  },
  data () {
    return {
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      },
      RequestsTablecolumns: [

        {
          label: '#',
          type: 'number',
          thClass: 'e-ts-12',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'სქრინინგ სტატუსი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'ScrStatus'
        },
        {
          label: 'მოთხოვნის სტატუსი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'statusText'
        },
        {
          label: 'დამუშავების შედეგი',
          field: 'Deci',
          thClass: 'e-mtavr-17 e-ts-08rem e-whitespace-nowrap',
          tdClass: 'text-center',
          type: 'text'
        },
        {
          label: 'დამუშავების %',
          field: 'matchPercent',
          thClass: 'e-mtavr-17 e-ts-08rem e-whitespace-nowrap',
          tdClass: 'text-center',
          type: 'number'
        },
        {
          label: 'დასახელება',
          html: true,
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12 e-whitespace-nowrap',
          field: 'SearchedCriteria'
        },
        {
          label: 'ძებნის დამატებითი პარამეტრი',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          html: true,
          field: 'FullAddress'
        },
        {
          label: 'იდენტიფიკატორი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'personalN'
        },
        {
          label: 'მოთხოვნის დრო',
          type: 'dateTime',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'recDate',
          formatFn: function (value) {
            if (value != null) {
              return moment(value).format('DD.MM.YYYY HH:mm:SS')
            }
            return 'თარიღი ცარიელია'
          }
        },
        {
          label: 'ტრანზაქციის ID',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'requestUniqueId'
        },
        {
          label: 'ბოლო კომენტარი',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          html: true,
          field: 'LastCommentItem'
        },
        {
          label: 'დამუშავების დაწყების დრო',
          type: 'dateTime',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12 e-nusx-8',
          field: 'investigationStartDate',
          formatFn: function (value) {
            if (value != null) {
              return moment(value).format('DD.MM.YYYY HH:mm:SS')
            }
            return 'თარიღი ცარიელია'
          }
        },
        {
          label: 'გადაწყვეტილების მიღების დრო',
          type: 'datetime',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12 e-nusx-8',
          field: 'statusChangeDate',
          formatFn: function (value) {
            if (value != null) {
              return moment(value).format('DD.MM.YYYY HH:mm:SS')
            }
            return 'თარიღი ცარიელია'
          }
        },
        {
          label: 'მომხმარებელი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12 e-nusx-8',
          field: 'LastActionUser'
        }
        // {
        //   label: 'ფუნქციები',
        //   field: 'functions',
        //   thClass: 'e-mtavr-17 e-ts-12',
        //   tdClass: 'e-ts-12'
        // }
      ],
      RequestsTablerows: [],
      tablefilter: false,
      loading: false,
      RR_Table_Columns: [
        {
          label: '#',
          type: 'number',
          thClass: 'e-ts-12',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'სქრინინგ სტატუსი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'ScrStatus',
          filterOptions: {
            placeholder: 'ყველა',
            filterDropdownItems: [
              { value: '0', text: 'არცერთი დამთხვევა' },
              { value: 'x', text: 'საყურადღებო' }
            ],
            // filterDropdownItems: ['არცერთი დამთხვევა', 'საყურადღებო'],
            enabled: true
          }
        },
        {
          label: 'მოთხოვნის სტატუსი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'statusText',
          filterOptions: {
            placeholder: 'ყველა',
            filterDropdownItems: ['დაუმუშავებელი', 'მუშავდება', 'მეორე დონის ავტორიზაციის მოლოდინში', 'დადასტურებული', 'დაბლოკილი'],
            enabled: true
          }
        },
        {
          label: 'სასურველი დამთხვევის %',
          field: 'matchPercent',
          thClass: 'e-mtavr-17 e-ts-08rem',
          tdClass: 'text-center',
          type: 'number'
        },
        {
          label: 'დამუშავების შედეგი',
          field: 'Deci',
          thClass: 'e-mtavr-17 e-ts-08rem',
          tdClass: 'text-center',
          type: 'text'
        },
        {
          label: 'საძიებო ტექსტი',
          html: true,
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'SearchedCriteria'
        },
        {
          label: 'მისამართი',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          html: true,
          field: 'FullAddress'
        },
        {
          label: 'იდენტიფიკატორი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'personalN'
        },
        {
          label: 'მოთხოვნის დრო',
          type: 'dateTime',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'recDate',
          formatFn: function (value) {
            if (value != null) {
              return moment(value).format('DD.MM.YYYY HH:mm:SS')
            }
            return 'თარიღი ცარიელია'
          }
        },
        {
          label: 'ტრანზაქციის ID',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'requestUniqueId'
        },
        {
          label: 'ბოლო კომენტარი',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          html: true,
          field: 'LastCommentItem'
        },
        {
          label: 'დამუშავების დაწყების დრო',
          type: 'dateTime',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12 e-nusx-8',
          field: 'investigationStartDate',
          formatFn: function (value) {
            if (value != null) {
              return moment(value).format('DD.MM.YYYY HH:mm:SS')
            }
            return 'თარიღი ცარიელია'
          }
        },
        {
          label: 'გადაწყვეტილების მიღების დრო',
          type: 'datetime',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12 e-nusx-8',
          field: 'statusChangeDate',
          formatFn: function (value) {
            if (value != null) {
              return moment(value).format('DD.MM.YYYY HH:mm:SS')
            }
            return 'თარიღი ცარიელია'
          }
        },
        {
          label: 'მომხმარებელი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12 e-nusx-8',
          field: 'LastActionUser'
        }
        // {
        //   label: 'ფუნქციები',
        //   field: 'functions',
        //   thClass: 'e-mtavr-17 e-ts-12',
        //   tdClass: 'e-ts-12'
        // }
      ],
      RR_Table_Rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: [{
          field: 'id',
          type: 'desc'
        }],
        page: 1,
        perPage: 5
      },
      filterType: 'requests'
    }
  },
  created () {
    this.loadItems()
    // const grsdata = {
    //   headers: {
    //     accept: 'text/plain',
    //     Authorization: ''
    //   }
    // }
    // grsdata.headers.Authorization = 'Bearer ' + this.$store.getters.getAccessToken
    // BaseService.GetRequests(grsdata)
    //   .then(response => {
    //     if (response.data.success) {
    //       for (var i = 0, len = response.data.result.length; i < len; i++) {
    //         response.data.result[i].brthDate === null ? response.data.result[i].brthDate = null : response.data.result[i].brthDate = moment(response.data.result[i].brthDate).format('DD.MM.YYYY')
    //         response.data.result[i].SearchedCriteria = 'სახელი და გვარი / დასახელება: <strong>' + response.data.result[i].firstName + ' ' + response.data.result[i].lastName + '</strong></br> დაბადების თარიღი: <strong>' + response.data.result[i].brthDate + '</strong>'
    //         response.data.result[i].FullAddress = 'ქვეყანა: <strong>' + response.data.result[i].country + '</strong></br> მისამართი: <strong>' + response.data.result[i].address + '</strong>'
    //         response.data.result[i].LastCommentItem = 'კომენტარი: <strong>' + response.data.result[i].commentText + '</strong></br> ავტორი: <strong>' + (response.data.result[i].commentUserName == null ? 'ავტორი არ არის ცნობილი' : response.data.result[i].commentUserName) + '</strong>'
    //         response.data.result[i].LastActionUser = response.data.result[i].userFirstName + ' ' + response.data.result[i].userLastName
    //       }
    //       this.RR_Table_Rows = response.data.result
    //       this.loading = false
    //     } else {
    //       return null
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })
  },
  methods: {
    // onColumnFilter (data) {
    //   if (data.columnFilters.ScrStatus === 0) {
    //     return this.RR_Table_Rows.matchPercent === 0
    //   }
    // },
    // filterCustomField (data) {
    //   console.log(data)
    // },
    filterToggle () {
      if (this.tablefilter) {
        this.tablefilter = false
      } else {
        this.tablefilter = true
      }
    },
    // გასასწორებელია
    exportToExcel () {
      this.loading = true
      // var RequestsExcelExportParams = {
      //   columnFilters: {},
      //   sort: [{
      //     field: 'id',
      //     type: 'desc'
      //   }],
      //   page: 1,
      //   perPage: this.totalRecords
      // }

      const filterPars = this.serverParams
      filterPars.perPage = this.totalRecords
      // filterPars.page = 4
      // filterPars.perPage = 100000
      BaseService.GetRequestsServerSide(this.header, filterPars)
        .then(res => {
          console.log(res.data)
          if (res.data.success) {
            for (var i = 0, len = res.data.result.requests.length; i < len; i++) {
              // eslint-disable-next-line no-debugger
              debugger
              // console.log(Date(res.data.result.requests[i].brthDate))
              // res.data.result.requests[i].brthDate === null ? res.data.result.requests[i].brthDate = null : res.data.result.requests[i].brthDate = moment(Date(res.data.result.requests[i].brthDate)).format('DD.MM.YYYY') === 'Invalid date' ? '' : moment(res.data.result.requests[i].brthDate).format('DD.MM.YYYY')
              // res.data.result.requests[i].SearchedCriteria = 'დასახელება : <strong>' + res.data.result.requests[i].firstName + ' ' + res.data.result.requests[i].lastName + '</strong></br> დაბადების თარიღი: <strong>' + res.data.result.requests[i].brthDate + '</strong>'
              res.data.result.requests[i].SearchedCriteria = res.data.result.requests[i].firstName + ' ' + res.data.result.requests[i].lastName
              res.data.result.requests[i].FullAddress = 'მისამართის ქვეყნები: <strong>' + res.data.result.requests[i].country + '</strong></br> მისამართის ქალაქები: <strong>' + res.data.result.requests[i].address + '</strong>'
              res.data.result.requests[i].LastCommentItem = 'კომენტარი: <strong>' + res.data.result.requests[i].commentText + '</strong></br> ავტორი: <strong>' + (res.data.result.requests[i].commentUserName == null ? 'ავტორი არ არის ცნობილი' : res.data.result.requests[i].commentUserName) + '</strong>'
              res.data.result.requests[i].LastActionUser = res.data.result.requests[i].userFirstName + ' ' + res.data.result.requests[i].userLastName
            }

            const sheetData = []
            var data = res.data.result.requests
            data.map(res => {
              sheetData.push({
                'მოთხოვნის უნიკალური #': res.id,
                'სქრინინგ სტატუსი': res.matchCount > 0 ? 'საყურადღებო' : 'არცერთი დამთხვევა',
                'მოთხოვნის სტატუსი': res.statusText,
                'დამუშავების შედეგი': res.decisions,
                'დამუშავების პროცენტი': res.matchPercent,
                'სახელი / დასახელება': res.firstName,
                გვარი: res.lastName,
                'დაბადების თარიღი': res.brthDate === null ? '' : moment(res.brthDate).format('DD.MM.YYYY'),
                სქესი: res.gender,
                ქვეყანა: res.country,
                ქალაქი: res.city,
                მისამართი: res.address,
                იდენტიფიკატორი: res.personalN,
                'მოთხოვნის დრო': res.recDate,
                'ტრანზაქციის ID': res.transactionN,
                // 'ბოლო კომენტარი': res.commentText,
                'დამუშავების დაწყების დრო': res.investigationStartDate === null ? '' : moment(res.investigationStartDate).format('DD.MM.YYYY HH:mm:SS'),
                'გადაწყვეტილების მიღების დრო': res.statusChangeDate === null ? '' : moment(res.statusChangeDate).format('DD.MM.YYYY HH:mm:SS'),
                // 'დამუშავების დაწყების დრო': res.data.result.requests.investigationStartDate === null ? '' : moment(res.data.result.requests.investigationStartDate).format('DD.MM.YYYY HH:mm:SS'),
                მომხმარებელი: res.userFirstName + ' ' + res.userLastName
              })
            })
            var newWB = XLSX.utils.book_new()
            var newWS = XLSX.utils.json_to_sheet(sheetData)
            XLSX.utils.book_append_sheet(newWB, newWS, 'Data')
            XLSX.writeFile(newWB, 'RequestsExport-' + moment(Date.now()).format('DD.MM.YYYY') + '.xlsx')
            this.loading = false
          }
        })
    },
    refreshRequests () {
      // console.log(grsdata.sessionId);
      BaseService.GetRequests(this.header)
        .then(response => {
          // eslint-disable-next-line no-debugger
          debugger
          if (response.data.success) {
            for (var i = 0, len = response.data.result.length; i < len; i++) {
              response.data.result[i].brthDate === null ? response.data.result[i].brthDate = null : response.data.result[i].brthDate = moment(response.data.result[i].brthDate).format('DD.MM.YYYY')
              // response.data.result[i].SearchedCriteria = 'დასახელება: <strong>' + response.data.result[i].firstName + ' ' + response.data.result[i].lastName + '</strong></br> დაბადების თარიღი: <strong>' + response.data.result[i].brthDate + '</strong>'
              response.data.result.requests[i].SearchedCriteria = response.data.result.requests[i].firstName + ' ' + response.data.result.requests[i].lastName
              response.data.result[i].FullAddress = 'ქვეყანა: <strong>' + response.data.result[i].country + '</strong></br> მისამართი: <strong>' + response.data.result[i].address + '</strong>'
              response.data.result[i].LastCommentItem = 'კომენტარი: <strong>' + response.data.result[i].commentText + '</strong></br> ავტორი: <strong>' + (response.data.result[i].commentUserName == null ? 'ავტორი არ არის ცნობილი' : response.data.result[i].commentUserName) + '</strong>'
              response.data.result[i].LastActionUser = response.data.result[i].userFirstName + ' ' + response.data.result[i].userLastName
            }
            this.RR_Table_Rows = response.data.result
          } else {
            return null
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    rowStyleClassFn (row) {
      if (row.statusText === 'მუშავდება') {
        return 'e-bg-investigating'
      }
      // if (row.statusText === 'დაუმუშავებელი') {
      //   return 'bg-secondary'
      // }
      if (row.statusText === 'დადასტურებული') {
        return 'e-bg-approved'
      }
      if (row.statusText === 'დაბლოკილი') {
        return 'e-bg-declined'
      }
      if (row.statusText === 'მეორე დონის ავტორიზაციის მოლოდინში') {
        return 'e-bg-secondaryApproval'
      }
      // if (row.matchCount === 0) {
      //   return 'border-success bg-transparent'
      // }
    },
    RR_Table_RowClick (params) {
      if (params.row.matchCount > 0) {
        console.log(params)
        const data = params.row
        const routeData = this.$router.resolve({
          name: 'InvestigatingRequest',
          query: { data, clientRequestId: params.row.id, requestUniqueId: params.row.requestUniqueId, rowIdentRecCountry: params.row.registrationCountry, rowIdentNumber: params.row.identityN, rowAddress: params.row.address, rowRegNumber: params.row.registrationN, rowPersonalN: params.row.personalN, rowBirthDate: params.row.brthDate }
        })
        window.open(routeData.href, '_blank')
        //   this.$router.push({
        //     path: 'Requests/InvestigatingRequest',
        //     query: { data, clientRequestId: params.row.id, requestUniqueId: params.row.requestUniqueId, rowIdentRecCountry: params.row.registrationCountry, rowIdentNumber: params.row.identityN, rowAddress: params.row.address, rowRegNumber: params.row.registrationN, rowPersonalN: params.row.personalN, rowBirthDate: params.row.brthDate }
        //   })
        // } else {
      }
    },
    updateParams (newProps) {
      console.log(newProps)
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },

    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },

    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },

    onSortChange (params) {
      let sort = []
      sort = params
      this.updateParams({
        sort
        // sort: [
        //   {
        //     type: params.sortType,
        //     // field: this.RequestsTablecolumns[params.columnIndex].field
        //     field: params
        //   }
        // ]
      })
      this.loadItems()
    },

    onColumnFilter (params) {
      if (params.columnFilters.matchPercent === '') {
        params.columnFilters.matchPercent = 0
      }
      if (params.columnFilters.matchCount) {
        params.columnFilters.matchCount = params.columnFilters.ScrStatus
        delete params.columnFilters.ScrStatus // no warning
      }
      if (params.columnFilters.matchPercent) {
        params.columnFilters.matchPercent = parseInt(params.columnFilters.matchPercent)
      }
      this.updateParams(params)
      this.loadItems()
    },

    // load items is what brings back the rows from server
    loadItems () {
      BaseService.GetRequestsServerSide(this.header, this.serverParams)
        .then(res => {
          if (res.data.success) {
            console.log(res)
            for (var i = 0, len = res.data.result.requests.length; i < len; i++) {
              res.data.result.requests[i].decisionsArry = res.data.result.requests[i].decisions !== null ? res.data.result.requests[i].decisions.split(',').map(word => word.trim()) : null
              res.data.result.requests[i].brthDate === null ? res.data.result.requests[i].brthDate = null : res.data.result.requests[i].brthDate = moment(res.data.result.requests[i].brthDate).format('DD.MM.YYYY')
              // res.data.result.requests[i].SearchedCriteria = 'დასახელება: <strong>' + res.data.result.requests[i].firstName + ' ' + res.data.result.requests[i].lastName + '</strong></br> დაბადების თარიღი: <strong>' + (res.data.result.requests[i].brthDate === null ? '' : res.data.result.requests[i].brthDate) + '</strong></br> სქესი: <strong>' + (res.data.result.requests[i].gender === null ? '' : res.data.result.requests[i].gender) + '</strong>'
              res.data.result.requests[i].SearchedCriteria = '<strong>' + res.data.result.requests[i].firstName + ' ' + res.data.result.requests[i].lastName + '</strong>'
              res.data.result.requests[i].FullAddress = '</strong>დაბადების თარიღი: <strong>' + (res.data.result.requests[i].brthDate === null ? '' : res.data.result.requests[i].brthDate) + '</strong></br> სქესი: <strong>' + (res.data.result.requests[i].gender === null ? '' : res.data.result.requests[i].gender) + '</strong></br>მის. ქვეყანა: <strong>' + res.data.result.requests[i].country + '</strong></br> მის. ქალაქი: <strong>' + res.data.result.requests[i].city + '</strong>'
              res.data.result.requests[i].LastCommentItem = 'კომენტარი: <strong>' + res.data.result.requests[i].commentText + '</strong></br> ავტორი: <strong>' + (res.data.result.requests[i].commentUserName == null ? 'ავტორი არ არის ცნობილი' : res.data.result.requests[i].commentUserName) + '</strong>'
              res.data.result.requests[i].LastActionUser = res.data.result.requests[i].userFirstName + ' ' + res.data.result.requests[i].userLastName
            }
            this.RequestsTablerows = res.data.result.requests
            this.totalRecords = res.data.result.totalNumber
          }
        })
      // console.log(this.serverParams)
    //   getFromServer(this.serverParams).then((res) => {
    //     this.totalRecords = res.totalRecords
    //     this.rows = res.rows
    //   })
    },
    onSearch (params) {
      if (params.searchTerm === '') {
        delete this.serverParams.columnFilters.SearchedCriteria
        this.loadItems()
      } else {
        this.serverParams.columnFilters.SearchedCriteria = params.searchTerm
        this.loadItems()
      }
    },
    filter (value) {
      console.log(value)
      if (value) {
        this.onColumnFilter(value)
      }
    }
  }
}
</script>
